export const GOOGLE_API = `https://maps.googleapis.com/maps/api/js?key=${
  import.meta.env.VITE_GOOGLE_API_KEY
}&libraries=places&v=weekly`;
